import { isRedirect } from "@tanstack/react-router";
import { ApplicationConfigNotFoundError } from "./application-api";
import { KnownGenericError } from "./errors";
import { VolumeApiError } from "./volume-api-errors";

export class MerchantAccessError extends KnownGenericError {
  constructor() {
    super({
      userFriendlyMessage: "You do not have access to this merchant account.",
    });
  }
}

export function shouldRetryQuery(failureCount: number, error: unknown) {
  if (
    isRedirect(error) ||
    error instanceof MerchantAccessError ||
    error instanceof ApplicationConfigNotFoundError
  )
    return false;
  if (
    error instanceof VolumeApiError &&
    (error.statusCode === 401 || error.statusCode === 403)
  )
    return false;
  return failureCount < 3;
}

export function queryRetry<T>(retry: T): T | false {
  if (import.meta.env.MODE === "test") return false;
  return retry;
}
